import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_PrivateHealthInformation = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_PrivateHealthInformation' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'>  <h3>Authorization for Release and/or Request of Private Health Information (PHI) </h3></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date:</span>
                        </td>
                        <td className='w-375'><span className='eleHeader'>Client's Full Name:  </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                        <td className='w-375'>
                            <input type='text' id='txtFullName' name='txtFullName' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>Client DOB:  </span></td>
                        <td className='w-375'><span className='eleHeader'>Client SS#: </span></td>

                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtDob' name='txtDob' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtClientName2' name='txtClientName2' className='add-only' /> </td>


                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Authorization to Release PHI To:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Authorization to Request PHI From:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTo' name='txtTo' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtFrom' name='txtFrom' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'><strong>PHI Authorized for Release is as follows:. </strong></td>
                        <td className='w-375'><strong>PHI Authorized for Request is as follows: </strong></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDiagnosis' name='cbDiagnosis' className='add-only' value='Diagnosis' /> Diagnosis </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDiagnosis1' name='cbDiagnosis1' className='add-only' value='Diagnosis1' /> Diagnosis </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTreatmentPlan' name='cbTreatmentPlan' className='add-only' value='Treatment Plan' /> Treatment Plan/Review/Addendum  </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTreatmentPlan1' name='cbTreatmentPlan1' className='add-only' value='Treatment Plan1' /> Treatment Plan/Review/Addendum  </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicePlan' name='cbServicePlan' className='add-only' value='Service Plan' /> Service Plan  </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicePlan1' name='cbServicePlan1' className='add-only' value='Service Plan1' /> Service Plan  </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicePlan11' name='cbServicePlan11' className='add-only' value='Progress Plan' /> Progress in Treatment Report </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTreatmentReport1' name='cbTreatmentReport1' className='add-only' value='Treatment Report1' /> Progress in Treatment Report </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbParticipationReport11' name='cbParticipationReport11' className='add-only' value='Participation Report11' /> Participation in Treatment Report </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbParticipationReport1' name='cbParticipationReport1' className='add-only' value='Participation Report1' /> Participation in Treatment Report </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDischargeSummary' name='cbDischargeSummary' className='add-only' value='Discharge Summary' /> Discharge Summary </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDischargeSummary1' name='cbDischargeSummary1' className='add-only' value='Discharge Summary1' /> Discharge Summary </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEducationalReport' name='cbEducationalReport' className='add-only' value='Educational Report' /> Educational Report</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEducationalReport1' name='cbEducationalReport1' className='add-only' value='Educational Report1' /> Educational Report</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychosocial' name='cbPsychosocial' className='add-only' value='Psychosocial' /> Psychosocial Development History </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychosocial1' name='cbPsychosocial1' className='add-only' value='Psychosocial1' /> Psychosocial Development History </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='Other' />  Other:
                            <input type='text' id='txtOther' name='txtOther' className='add-only w-250 custom-add-only' /> </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther1' name='cbOther1' className='add-only' value='Other1' />  Other:
                            <input type='text' id='txtOther1' name='txtOther1' className='add-only w-250 custom-add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>PHI is Authorized for Release/Request for the Purpose of</span>
                    <textarea id='txtAuthorized' name='txtAuthorized' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Restrictions Regarding the Release/Request of PHI are: </span>
                    <textarea id='txtRestrictions' name='txtRestrictions' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSignature' name='cbSignature' className='add-only' value='signature' /> I understand that PHI regarding me or my child/ward will not be released without this form being complete including my signature
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbSignature1' name='cbSignature1' className='add-only' value='signature1' /> I understand that Right Path Behavioral Health Services will release the minimal amount of information necessary to fulfill a request
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbRevoke' name='cbRevoke' className='add-only' value='revoke' />
                    I understand that I have the right to revoke consent for release/request of PHI on behalf of myself or my child/ward at any time in writing and in person
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbRequest' name='cbRequest' className='add-only' value='request' /> I understand that I have the right to request a copy of my authorization to release/request PHI and that my authorization to release/request PHI is guided via State and Federal Confidentiality Regulations Title 42 (C.F.R.) Part 2, Florida Statute (F.S.) 90.503, and the Health Insurance Portability and Accountability Act (HIPAA)
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbAuthorizing' name='cbAuthorizing' className='add-only' value='authorizing' /> I understand that authorizing the release/request of PHI is voluntary and in no way will affect treatment, fees for treatment, or any aspect of treatment
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbAuthorization' name='cbAuthorization' className='add-only' value='authorization' />
                    I understand that this authorization will remain in effect for a period of one year unless revoked sooner by me.
                </p>

                
            </div>
        </form>

    )
}











